import { message } from 'antd';
import axios from 'axios';
import { AUTH_DATA_KEY } from '../../context/auth-context';

export const authApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
    (config) => {
        const user = JSON.parse(localStorage.getItem(AUTH_DATA_KEY));

        if (user) {
            const bearerAuth = `Bearer ${user.accessToken}`;
            config.headers['Authorization'] = bearerAuth;
        }

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            message.error(error);

            localStorage.removeItem(AUTH_DATA_KEY);
            window.location = '/login';
        }

        return Promise.reject(error);
    }
);

export default api;
